import actionTypes from '../actionTypes';

export function successGlobalAccount( data ) {
  return {
    type: actionTypes.GLOBALACCOUNT_SUCCESS,
    globalAccountIn: data
  };
}

export function addNewAccounts( newAccountsData ) {
  return {
    type: actionTypes.ADD_ACCOUNTS_DATA,
    newAccountsData
  };
}

export function removeAccountsData( oldAccountsData ) {
  return {
    type: actionTypes.REMOVE_ACCOUNTS_DATA,
    oldAccountsData
  };
}

export function refreshAccountsData ({ currentClub }) {
  return {
    type: actionTypes.REFRESH_ACCOUNTS_DATA_REQUEST,
    currentClub
  };
}

export function requestRefreshAccountBalance ({ accountData }) {
  return {
    type: actionTypes.REFRESH_ACCOUNT_BALANCE_REQUEST,
    accountData
  };
}

export function refreshAccountBalanceSuccess ( updatedBalance ) {
  return {
    type: actionTypes.REFRESH_ACCOUNT_BALANCE_SUCCESS,
    updatedBalance
  };
}

export function refreshAccountsDataSuccess ({ changedAccountsData, forcedUpdatedClub,
  updatedPlayerBalance, updatedAgentBalance, updatedManagerBalance }) {
  return {
    type: actionTypes.REFRESH_ACCOUNTS_DATA_SUCCESS,
    changedAccountsData,
    forcedUpdatedClub,
    updatedPlayerBalance,
    updatedAgentBalance,
    updatedManagerBalance
  };
}

export function refreshAccountsDataFailure ({ changedAccountsData }) {
  return {
    type: actionTypes.REFRESH_ACCOUNTS_DATA_FAILURE,
    changedAccountsData
  };
}

export function changePasswordRequest ({ password, newPassword , repeatPassword}) {
  return {
    type: actionTypes.CHANGE_PASSWORD_REQUEST,
    value: { password, newPassword, repeatPassword }
  };
}

export function changePasswordSuccess ( changedPasswordMessage ) {
  return {
    type: actionTypes.CHANGE_PASSWORD_SUCCESS,
    changedPasswordMessage
  };
}

export function changePasswordFailure ( changePasswordFail ) {
  return {
    type: actionTypes.CHANGE_PASSWORD_FAILURE,
    changePasswordFail
  };

}

export function closeForm (changePasswordFail) {
  return {
    type: actionTypes.CLOSE_FORM,
    changePasswordFail
  }
}

export function sendVerificationCode ({ email }) {
  return {
    type: actionTypes.LINK_EMAIL_VERIFICATION_REQUEST,
    value: email
  }
}

export function sendVerificationCodeSuccess ({ verificationCode }) {
  return {
    type: actionTypes.LINK_EMAIL_VERIFICATION_SUCCESS,
    value: verificationCode
  }
}

export function codeVerifySuccess ({}) {
  return {
    type: actionTypes.LINK_EMAIL_VERIFICATION_CODE_SUCCESS,
  }
}

export function sendVerificationCodeFailure ({ }) {
  return {
    type: actionTypes.LINK_EMAIL_VERIFICATION_FAILURE
  }
}
